import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IRefusedState } from './refused.state';

export class RefusedSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly refusedState = (state: IRootState): IRefusedState => {
    return state.refused as IRefusedState;
  };

  static readonly model = createSelector(RefusedSelectors.refusedState, (refused: IRefusedState) => {
    return refused.model;
  });

  static readonly data = createSelector(RefusedSelectors.refusedState, (refused: IRefusedState) => {
    return refused.data;
  });
}
